module.exports = __webpack_public_path__ + "ptc_nakagawa_M1.3ebd8904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_M1.jpg
// module id = E6p3
// module chunks = 0